const initialState = [
  {
    liveCategories: [],
    isLoading: false,
  },
];

const liveCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_REDUCER_STATE":
      return {
        ...initialState,
      };
    case "LIVE_CATEGORY":
      return {
        ...state,
        liveCategories: action.payload,
      };
    case "LOADING_START":
      return {
        ...state,
        isLoading: true,
      };
    case "LOADING_END":
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default liveCategoryReducer;
